import { history } from '../../../utils/history'

export const subscribeToPathnameChange = (listener: () => void): (() => void) => {
  let previousPathname = history.location.pathname

  return history.listen(({ location }) => {
    if (location.pathname === previousPathname) {
      return
    }
    previousPathname = location.pathname
    listener()
  })
}
